module.exports = __webpack_public_path__ + "static/media/linkedin-logo.5a653ec3.png";